import { getVictoryLabelFontSize } from 'helpers/style';

const colorTextLight = '#7f7f7f';
const colorUi90 = '#333333';
export const colorDirectFill = 'rgba(0, 85, 255, 0.12)'; // Light blue
export const colorSmartSpotFill = '#0055FF'; // Dark blue
export const colorUnfilled = '#E8E8E8'; // Light gray for unfilled spots
export const colorGridLine = '#e0e0e0'; // Grid line color for y-axis
const semibold = 500;
const spacingTiny = 4;

export const getSmartSpotFillChartTheme = locale => {
  const tickLabelFontSize = getVictoryLabelFontSize(locale);

  return {
    axis: {
      style: {
        tickLabels: {
          fontFamily: 'inherit',
          fontSize: tickLabelFontSize,
          fill: colorTextLight,
          fontWeight: semibold,
          padding: spacingTiny,
        },
        axis: {
          fill: 'transparent',
          stroke: colorUi90,
          opacity: 0.062745098,
          strokeWidth: 1,
        },
        grid: {
          stroke: colorUi90,
          opacity: 0.1,
          strokeWidth: 1,
          pointerEvents: 'painted',
        },
      },
    },
    stack: {
      colorScale: [colorDirectFill, colorSmartSpotFill],
    },
    bar: {
      style: {
        data: {
          strokeWidth: 0,
        },
      },
    },
  };
};
